import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Field, Form, Formik } from 'formik';

import { ReactComponent as LockIcon } from '../../../../assets/images/lockIcon.svg';
import Button from '../../../../components/shared/Button/Button';
import CustomPasswordField from '../../../../components/shared/CustomPasswordField/CustomPasswordField';
import { MIN_PASSWORD_LENGTH } from '../../../../constants/commonConstants';
import { updatePassword } from '../../../../redux/actions/userActions';

import styles from './ChangePassword.module.scss';

const INITIAL_VALUES = {
  old_password: '',
  new_password: '',
  repeat_password: '',
};

const ChangePassword = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const [showValidation, setShowValidation] = useState(false);

  const userId = useSelector((state) => state.authReducer.currentUser?.user?.id);

  const handleSubmit = useCallback((data, { resetForm }) => {
    dispatch(updatePassword(userId, data.old_password, data.new_password));
    resetForm();
  }, []);

  return (
    <div className={styles.container}>
      <p className={styles.contentHeading}>{t('account.changePassword')}</p>
      <div className={styles.formContainer}>
        <Formik initialValues={INITIAL_VALUES} onSubmit={handleSubmit} enableReinitialize>
          {({ values }) => {
            const disabled = !(
              values.old_password &&
              values.new_password &&
              values.repeat_password &&
              values.new_password.length >= MIN_PASSWORD_LENGTH &&
              values.new_password === values.repeat_password
            );

            return (
              <Form>
                <div className={styles.fieldsContainer}>
                  <Field name="old_password" label={t('account.currentPassword')} as={CustomPasswordField} />
                  <Field
                    onBlur={() => setShowValidation(true)}
                    onFocus={() => setShowValidation(false)}
                    name="new_password"
                    label={t('account.newPassword')}
                    as={CustomPasswordField}
                  />
                  <Field
                    onBlur={() => setShowValidation(true)}
                    onFocus={() => setShowValidation(false)}
                    name="repeat_password"
                    label={t('account.repeatPassword')}
                    as={CustomPasswordField}
                  />
                  {values.new_password !== values.repeat_password && (
                    <span className={showValidation ? 'd-block' : 'd-none'}>{t('account.passwordsDontMatch')}</span>
                  )}
                  {values.new_password.length < MIN_PASSWORD_LENGTH && (
                    <span className={showValidation ? 'd-block' : 'd-none'}>{t('account.passwordMinLength')}</span>
                  )}
                  <Button
                    variant="outline-primary"
                    type="submit"
                    className={styles.changePasswordButton}
                    disabled={disabled}
                  >
                    <LockIcon fill={disabled ? '#D1D8DC' : '#0FBC71'} />
                    <span>{t('account.changePassword')}</span>
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
